var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCanada = function SvgCanada(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.557 0h16.904v24H3.557z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D52B1E",
    d: "M-5 0h8.503v24H-5zm25.514 0h8.503v24H20.52l-.005-24ZM6.053 11.597l-.667.225 3.075 2.695c.235.69-.08.89-.281 1.256l3.333-.421-.08 3.351.695-.019-.155-3.328 3.344.399c-.207-.436-.39-.666-.202-1.36l3.07-2.554-.535-.197c-.441-.338.188-1.627.282-2.442 0 0-1.79.614-1.906.29l-.46-.876-1.63 1.79c-.178.042-.253-.028-.296-.178l.752-3.74-1.193.67c-.099.047-.197.01-.263-.108l-1.15-2.297-1.184 2.386c-.089.084-.178.094-.253.038l-1.136-.638.685 3.708c-.056.15-.188.187-.338.108L7.997 8.587c-.202.329-.338.858-.61.98-.268.113-1.175-.225-1.78-.356.206.745.854 1.983.446 2.39z"
  })));
};
export default SvgCanada;